import React, { useState } from 'react';
import { Box, MenuItem, FormControl, Select, Button } from '@mui/material';
import WindowWrapper from '../../utils/windowWrapper';
import { Page } from '../layout';

const submitLogin = userId => {
  WindowWrapper.setLocation(process.env.API_BASE_URL + '/sso/login?userId=' + userId);
};

const DevelopmentLoginPage = () => {
  const [selectedId, setSelectedId] = useState(-1);
  const pageTitle = 'Development login';

  return (
    <Page title={pageTitle}>
      <Box sx={{ minWidth: 125 }}>
        <h3>Development Login</h3>
        <p>Sign in with a local development persona.</p>
        <FormControl variant='standard' fullWidth>
          <Select
            variant='standard'
            id='userSelection'
            value={selectedId}
            onChange={event => setSelectedId(event.target.value)}
            name='user'>
            <MenuItem value='-1'>FDA Admin</MenuItem>
            <MenuItem value='-2'>FDA Reviewer</MenuItem>
            <MenuItem value='-3'>Org Sponsor</MenuItem>
            <MenuItem value='-4'>Org Coordinator</MenuItem>
            <MenuItem value='-6'>Org Unit Sponsor</MenuItem>
            <MenuItem value='-7'>Org Unit Coordinator</MenuItem>
            <MenuItem value='150253'>ISACA MDDAP Appraiser ATL</MenuItem>
            <MenuItem value='151557'>ISACA MDDAP Appraiser ATL Observer</MenuItem>
            <MenuItem value='151813'>ISACA MDDAP Appraiser ATM</MenuItem>
            <MenuItem value='-9'>Org Sponsor With Invalid OrgId</MenuItem>
            <MenuItem value='-10'>Org Unit Sponsor With Invalid Org Id</MenuItem>
            <MenuItem value='-11'>Org Unit Sponsor With Invalid Org Unit Ids</MenuItem>
            <MenuItem value='-12'>FDA Admin + MDDAP Super User</MenuItem>
            <MenuItem value='-13'>Org Sponsor + MDDAP Super User</MenuItem>
            <MenuItem value='-14'>Org Unit Coordinator + MDDAP Super User</MenuItem>
            <MenuItem value='-15'>FDA Admin with specific units</MenuItem>
            <MenuItem value='-16'>FDA Admin with specific Orgs</MenuItem>
            <MenuItem value='-17'>VIP Portal Admin</MenuItem>
            <MenuItem value='-18'>VIP Partner</MenuItem>
            <MenuItem value='-19'>VIP Partner + MDDAP Super User</MenuItem>
            <MenuItem value='-20'>VIP Free License User</MenuItem>
            <MenuItem value='-23'>FDA ATM User</MenuItem>
            <MenuItem value='-24'>Deactivated User</MenuItem>

            <MenuItem value='152105'>Real User - Internal ATM User</MenuItem>
            <MenuItem value='150922'>Real User - Dev - VIP Portal Admin</MenuItem>
            <MenuItem value='152099'>Real User - Dev - FDA ATM User</MenuItem>
            <MenuItem value='152004'>Real User - Dev - Org Sponsor ATM</MenuItem>
            <MenuItem value='152091'>Real User - Dev - Org Coordinator ATM</MenuItem>

            <MenuItem value='-99'>Invalid User</MenuItem>
          </Select>
        </FormControl>

        <Button
          style={{
            position: 'fixed',
            right: '50px',
            bottom: '500px'
          }}
          variant='contained'
          onClick={() => submitLogin(selectedId)}>
          Login
        </Button>
      </Box>
    </Page>
  );
};

export default DevelopmentLoginPage;
